import { LoadingIndicator } from '@cfa/react-components';
import styled from 'styled-components';

const LoadingPage: React.FC = () => (
  <StyledSpinnerWrapper>
    <LoadingIndicator data-cy="loading-page" data-testid="spinner" size="md" variant="page" />
  </StyledSpinnerWrapper>
);

const StyledSpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20vh auto;
`;

export default LoadingPage;
